import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SolEstimateTableRowBase } from '../../../models/sol-estimate-table/SolEstimateTableRowBase';
import { MultilingualCurrencyPipe } from "../../../pipes/multilingual-currency-pipe/multilingual-currency.pipe";
import { DecimalPrecisionPipe } from "../../../pipes/decimal-precision-pipe/decimal-precision.pipe";

@Component({
  selector: 'app-sol-estimate-table-sub-totals',
  imports: [
    TranslatePipe,
    MultilingualCurrencyPipe,
    DecimalPrecisionPipe
],
  templateUrl: './sol-estimate-table-sub-totals.component.html',
  styleUrl: './sol-estimate-table-sub-totals.component.scss'
})
export class SolEstimateTableSubTotalsComponent {

  @Input() subTotalsFormGroup: FormGroup<SolEstimateTableRowBase>;

}
